module.exports = "/assets/mobile-banner/fdw.jpg?kympyHL";